// extracted by mini-css-extract-plugin
export default {"questionInput":"style_questionInput__2Rdnd","action":"style_action__aSCUY"};